@use "sass:map";
@use "../../../src/scss/abstracts/utilities";
@use "../../../src/scss/abstracts/breakpoints";

:host {
  display: grid;
  grid-template-columns: auto auto auto;
  gap: utilities.toRem(16px);
  justify-items: center;
  align-items: center;
  @media (width >= map.get(breakpoints.$grid-breakpoints, "md")) {
    justify-content: start;
    justify-items: start;
    gap: utilities.toRem(60px);
  }

  .uspto-logo {
    width: 100%;
    max-width: utilities.toRem(160px);

    > img {
        width: 100%;
        height: auto;
    }
  }

  .zero-injuries-badge {
    width: utilities.toRem(140px);
    height: auto;
    @media (width >= map.get(breakpoints.$grid-breakpoints, "md")) {
      //justify-self: center;
      width: utilities.toRem(111px);
    }
    @media (width >= map.get(breakpoints.$grid-breakpoints, "lg")) {
      //justify-self: center;
    }
  }


  .hasc-logo {
    width: 100%;
    max-width: utilities.toRem(160px);

    > img {
        width: 100%;
        height: auto;
    }
  }
}
